export var LoginMethod = /*#__PURE__*/ function(LoginMethod) {
    LoginMethod["Password"] = "password";
    LoginMethod["OTP"] = "otp";
    LoginMethod["Google"] = "google";
    LoginMethod["Apple"] = "apple";
    LoginMethod["Xero"] = "xero";
    LoginMethod["Intuit"] = "intuit";
    return LoginMethod;
}({});
